import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { translate, TranslocoPipe } from '@jsverse/transloco';
import { DialogComponent, InputComponent } from 'vcp-common-ui-lib';

@Component({
    selector: 'vc-disable-mfa-dialog',
    templateUrl: './disable-mfa-dialog.component.html',
    styleUrls: ['./disable-mfa-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslocoPipe, DialogComponent, InputComponent],
})
export class DisableMfaDialogComponent {
    dialogTitle = translate('ACCOUNT.DISABLE_MFA');
    verificationCode!: string;

    @Input()
    set visible(value: boolean) {
        if (value !== this._visible) {
            this._visible = value;
            this.visibleChange.emit(this._visible);
        }
    }
    get visible(): boolean {
        return this._visible;
    }
    private _visible = false;

    @Output()
    disableMFA = new EventEmitter<string>();

    @Output()
    cancelled = new EventEmitter<void>();

    @Output()
    visibleChange = new EventEmitter<boolean>();

    nextStep() {
        if (this.verificationCode || this.verificationCode !== '') {
            this.disableMFA.emit(this.verificationCode);
            this.visible = false;
        }
    }
}
